import { css, sva } from "@stubhub/broadway-foundation/css";

export const fanProtectBannerContainer = css({
  // DESKTOP_PERFORMER_INFO_CARD_WIDTH from stubhub-performer/components/performer-info-card/PerformerInfoCard.styled.ts
  width: "[400px]",
  marginBlockStart: "primitives.200",
});

export const trustCardContainer = css({
  width: "[400px]",
  marginBlockStart: "primitives.300",
});

export const recentlyViewedCarouselContainer = css({
  marginBlockEnd: "primitives.200",
});

export const doubleCarouselContainer = css({
  display: "flex",
  flexDirection: "column",
  rowGap: "primitives.100",
  desktop: {
    rowGap: "primitives.200",
  },
});

export const PLAYOFF_ALERT_ONBOARDING_CSS_VARS = {
  primaryColor: "--component-primary-color",
} as const satisfies Record<string, `--component-${string}`>;

const playoffAlertOnboardingSlots = ["button", "ctaContainer", "bodyContainer", "endIcon"] as const;
export const playoffAlertOnboardingRecipe = sva({
  slots: playoffAlertOnboardingSlots,
  className: "playoffAlertOnboarding",
  base: {
    button: {
      display: "flex",
      alignItems: "center",
      width: "full",
      paddingBlock: "primitives.200",
      paddingInline: "primitives.200",
      columnGap: "primitives.200",
      borderStartRadius: "container",
      borderEndRadius: "container",
      borderBlockWidth: "thin",
      borderInlineWidth: "thin",
      borderBlockColor: "border",
      borderInlineColor: "border",
      backgroundColor: "bg.surface.stronger",
      cursor: "pointer",
      "&:not(:first-child)": {
        marginBlockStart: "primitives.200",
      },
      "&:not(:last-child)": {
        marginBlockEnd: "primitives.200",
      },
      desktop: {
        width: "[400px]",
      },
    },
    ctaContainer: {
      paddingBlock: "primitives.175",
      paddingInline: "primitives.200",
      backgroundColor: "var(--component-primary-color, {colors.bg.dark})",
      color: "text.onFill",
      borderStartRadius: "element.default",
      borderEndRadius: "element.default",
      tablet: {
        borderStartRadius: "element.small",
        borderEndRadius: "element.small",
      },
    },
    bodyContainer: {
      display: "flex",
      flexDirection: "column",
      rowGap: "primitives.50",
      textAlign: "start",
      flexGrow: 1,
      flexBasis: "auto",
    },
    endIcon: {
      flexGrow: 0,
      flexShrink: 0,
      color: "text.subtle",
    },
  },
});
